module.exports = __webpack_public_path__ + "04d20f433c8f10163ff7b7668210cac1.jpg";